<script setup>
import DialogModal from "../Components/DialogModal.vue";
import { useForm, usePage } from "@inertiajs/vue3";
import { onMounted, onUnmounted, reactive } from "vue";
import eventBus from "@/Helpers/eventBus";
import Button from "../Components/Button.vue";
import InputError from "@/Components/InputError.vue";
import JetButton from "@/Components/PrimaryButton.vue";
import JetLabel from "@/Components/InputLabel.vue";
import JetTextarea from "@/Components/Textarea.vue";

const props = defineProps({
    entityName: {
        type: String,
        required: true,
    },
});

const modal = reactive({
    show: false,
});
const form = useForm({
    subject: `About your ${props.entityName} (${usePage().props[props.entityName].name}) from ${usePage().props.user.name}`,
    contents: null,
});

function showModal() {
    modal.show = true;
}

function closeModal() {
    //console.log(arguments);
    modal.show = false;
    form.reset();
    form.clearErrors();
}

onMounted(() => {
    // console.log("onMounted CompetitorFormModal");
    eventBus.$on("showSendMessageModal", (argsObj) => {
        showModal();
    });
});

onUnmounted(() => {
    // console.log("onUnmounted CompetitorFormModal");
    eventBus.$off("showSendMessageModal");
});

function createDocument() {
    if (props.entityName === "track") {
        form.post(
            route(`track.public.send-email-message`, [
                usePage().props.track.pin,
                usePage().props.track.seo_slug,
            ]),
            {
                preserveScroll: true,
                onSuccess: () => closeModal(),
            },
        );
    }

    if (props.entityName === "event") {
        form.post(
            route(`event.public.send-email-message`, [
                usePage().props.event.hashid,
                usePage().props.event.seo_slug,
            ]),
            {
                preserveScroll: true,
                onSuccess: () => closeModal(),
            },
        );
    }
}
</script>

<template>
    <DialogModal
        :show="modal.show"
        @close="closeModal()"
    >
        <template
            v-if="props.entityName === 'track'"
            #title
            >Send an email to the track creator/owner</template
        >
        <template
            v-if="props.entityName === 'event'"
            #title
            >Send an email to the event organizer</template
        >

        <template #content>
            <div class="mt-4">
                <p>From: {{ $page.props.user.name }} &lt;{{ $page.props.user.email }}&gt;</p>
                <div class="flex-1">
                    <div class="mt-4">
                        <jet-label
                            for="modalSendEmail-subject"
                            value="Email Subject"
                        />
                        <input
                            id="modalSendEmail-subject"
                            ref="modalSendEmail-subject"
                            v-model="form.subject"
                            type="text"
                            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 sm:w-full"
                            disabled
                            :class="{
                                'border-red-600 ': form.errors.subject,
                            }"
                        />
                        <input-error
                            :message="form.errors.subject"
                            class="mt-2"
                        />
                    </div>
                </div>

                <div class="mt-4">
                    <jet-label
                        for="modalSendEmail-contents"
                        value="Email contents"
                    />
                    <jet-textarea
                        v-model="form.contents"
                        placeholder="Hi, ..."
                        class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50 sm:w-full"
                        :class="{
                            'border-red-600 ': form.errors.contents,
                        }"
                    >
                    </jet-textarea>
                    <input-error
                        :message="form.errors.contents"
                        class="mt-2"
                    />
                </div>
            </div>
        </template>

        <template #footer>
            <Button
                color="white"
                @click="closeModal()"
            >
                Cancel
            </Button>
            <jet-button
                class="ml-3"
                :class="{ 'opacity-25': form.processing }"
                :disabled="form.processing"
                @click="createDocument()"
            >
                <span> Send Email</span>
            </jet-button>
        </template>
    </DialogModal>
</template>
